var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "dashboard-v2" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 40 } },
          [
            _c("el-col", { attrs: { xs: 24, sm: 12, lg: 8 } }, [
              _c("div", { staticClass: "left-card load-up" }, [
                _c("div", { staticClass: "profile-img" }, [
                  _c(
                    "span",
                    { staticStyle: { "font-size": "5.2em", color: "Teal" } },
                    [_c("i", { staticClass: "fas fa-envelope-open-text" })]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v("\n              代理名称\n            ")
                  ]),
                  _vm._v(" "),
                  !_vm.loadingUser
                    ? _c("div", { staticClass: "value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.user.agentAccount) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("dashboard.agent.enterpriseRechargeTotal")
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.loadingUser
                    ? _c(
                        "div",
                        { staticClass: "value" },
                        [
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val": _vm.user.organizationAmount,
                              duration: 2600
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("dashboard.agent.numOfOrgs")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.loadingProfile
                    ? _c(
                        "div",
                        { staticClass: "value" },
                        [
                          _c("count-to", {
                            staticClass: "card-panel-num",
                            attrs: {
                              "start-val": 0,
                              "end-val":
                                _vm.profile
                                  .organizationNumberActiveInLastTenDay,
                              duration: 2600
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("dashboard.lastLoginTime")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.loadingUser
                    ? _c("div", { staticClass: "value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.user.lastLoginTime) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "profile-info" }, [
                  _c("div", { staticClass: "label" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("dashboard.lastLoginIp")) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.loadingUser
                    ? _c("div", { staticClass: "value" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.user.lastLoginIp) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { xs: 24, sm: 12, lg: 16 } },
              _vm._l(_vm.cardInfo, function(infoPair, i) {
                return _c("CardInfo", {
                  key: i,
                  attrs: {
                    infoPair: infoPair,
                    loadingProfile: _vm.loadingProfile
                  }
                })
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("el-row", [
          _c("div", { staticClass: "card-style" }, [
            _c(
              "div",
              { staticClass: "chart-wrapper load-up" },
              [
                _c("div", { staticClass: "graph-title" }, [
                  _vm._v(_vm._s(_vm.$t("dashboard.agent.top5Orgs")))
                ]),
                _vm._v(" "),
                _vm.values.length
                  ? _c("bar-chart", {
                      ref: "barChart",
                      attrs: {
                        labels: _vm.labels,
                        values: _vm.values,
                        placeholder: _vm.$t("dashboard.agent.SmsSent")
                      }
                    })
                  : _c("div", { staticClass: "no-data" }, [
                      _vm._v(_vm._s(_vm.$t("common.noData")))
                    ])
              ],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }